import { getValueByPath } from '@utils/utils/util';

export const getCell = function(event) {
  let cell = event.target;

  while (cell && cell.tagName.toUpperCase() !== 'HTML') {
    if (cell.tagName.toUpperCase() === 'TD') {
      return cell;
    }
    cell = cell.parentNode;
  }

  return null;
};

export const getThTextCell = function(event) {
  let cell = event.target.querySelector('.cell-cont');
  return cell;
};

const isObject = function(obj) {
  return obj !== null && typeof obj === 'object';
};

export const orderBy = function(array, sortKey, reverse, sortMethod, sortBy) {
  if (
    !sortKey &&
    !sortMethod &&
    (!sortBy || (Array.isArray(sortBy) && !sortBy.length))
  ) {
    return array;
  }
  if (typeof reverse === 'string') {
    reverse = reverse === 'desc' ? -1 : 1;
  } else {
    reverse = reverse && reverse < 0 ? -1 : 1;
  }
  const getKey = sortMethod
    ? null
    : function(value, index) {
      if (sortBy) {
        if (!Array.isArray(sortBy)) {
          sortBy = [sortBy];
        }
        return sortBy.map(function(by) {
          if (typeof by === 'string') {
            return getValueByPath(value, by);
          } else {
            return by(value, index, array);
          }
        });
      }
      if (sortKey !== '$key') {
        if (isObject(value) && '$value' in value) value = value.$value;
      }
      return [isObject(value) ? getValueByPath(value, sortKey) : value];
    };
  const compare = function(a, b) {
    if (sortMethod) {
      return sortMethod(a.value, b.value);
    }
    for (let i = 0, len = a.key.length; i < len; i++) {
      if (a.key[i] < b.key[i]) {
        return -1;
      }
      if (a.key[i] > b.key[i]) {
        return 1;
      }
    }
    return 0;
  };
  return array
    .map(function(value, index) {
      return {
        value: value,
        index: index,
        key: getKey ? getKey(value, index) : null
      };
    })
    .sort(function(a, b) {
      let order = compare(a, b);
      if (!order) {
        // make stable https://en.wikipedia.org/wiki/Sorting_algorithm#Stability
        order = a.index - b.index;
      }
      return order * reverse;
    })
    .map(item => item.value);
};

export const getColumnById = function(table, columnId) {
  let column = null;
  table.columns.forEach(function(item) {
    if (item.id === columnId) {
      column = item;
    }
  });
  return column;
};

export const getColumnByKey = function(table, columnKey) {
  let column = null;
  for (let i = 0; i < table.columns.length; i++) {
    const item = table.columns[i];
    if (item.columnKey === columnKey) {
      column = item;
      break;
    }
  }
  return column;
};

export const getColumnByCell = function(table, cell) {
  const matches = (cell.className || '').match(/yxt-table_[^\s]+/gm);
  if (matches) {
    return getColumnById(table, matches[0]);
  }
  return null;
};

export const getRowIdentity = (row, rowKey) => {
  if (!row) throw new Error('row is required when get row identity');
  if (typeof rowKey === 'string') {
    if (rowKey.indexOf('.') < 0) {
      return row[rowKey];
    }
    let key = rowKey.split('.');
    let current = row;
    for (let i = 0; i < key.length; i++) {
      current = current[key[i]];
    }
    return current;
  } else if (typeof rowKey === 'function') {
    return rowKey.call(null, row);
  }
};

export const getKeysMap = function(array, rowKey) {
  const arrayMap = {};
  (array || []).forEach((row, index) => {
    arrayMap[getRowIdentity(row, rowKey)] = { row, index };
  });
  return arrayMap;
};
// 跟进map 返回数组
export const getValuesFromMap = function(map) {
  return Object.keys(map).map((key) => map[key].row);
};

function hasOwn(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
}

export function mergeOptions(defaults, config) {
  const options = {};
  let key;
  for (key in defaults) {
    options[key] = defaults[key];
  }
  for (key in config) {
    if (hasOwn(config, key)) {
      const value = config[key];
      if (typeof value !== 'undefined') {
        options[key] = value;
      }
    }
  }
  return options;
}

export function parseWidth(width) {
  if (width !== undefined) {
    width = parseInt(width, 10);
    if (isNaN(width)) {
      width = null;
    }
  }
  return width;
}

export function parseMinWidth(minWidth) {
  if (typeof minWidth !== 'undefined') {
    minWidth = parseWidth(minWidth);
    if (isNaN(minWidth)) {
      minWidth = 80;
    }
  }
  return minWidth;
}

export function parseHeight(height) {
  if (typeof height === 'number') {
    return height;
  }
  if (typeof height === 'string') {
    if (/^\d+(?:px)?$/.test(height)) {
      return parseInt(height, 10);
    } else {
      return height;
    }
  }
  return null;
}

// https://github.com/reduxjs/redux/blob/master/src/compose.js
export function compose(...funcs) {
  if (funcs.length === 0) {
    return arg => arg;
  }
  if (funcs.length === 1) {
    return funcs[0];
  }
  return funcs.reduce((a, b) => (...args) => a(b(...args)));
}

export function toggleRowStatus(statusArr, row, newVal, rowKey, skipPrivate = false, selectByRowKey = false) {
  let changed = false;
  let index = -1;
  if (!selectByRowKey) {
    index = statusArr.indexOf(row);
  } else {
    index = statusArr.findIndex((e) => {
      return e[rowKey] === row[rowKey];
    });
  }

  if (!newVal) {
    statusArr.forEach((item, i) => {
      let exist;
      if (rowKey) {
        exist = getRowIdentity(item, rowKey) === getRowIdentity(row, rowKey);
      } else {
        exist = Object.keys(item)
          .filter(key => {
            if (skipPrivate) {
              return key && !key.startsWith('_');
            } else {
              return true;
            }
          })
          .every(key => {
            return item[key] === row[key];
          });
      }

      if (exist) {
        index = i;
      }
    });
  }
  const included = index !== -1;
  const addRow = () => {
    statusArr.push(row);
    changed = true;
  };
  const removeRow = () => {
    statusArr.splice(index, 1);
    changed = true;
  };
  if (typeof newVal === 'boolean') {
    if (newVal && !included) {
      addRow();
    } else if (!newVal && included) {
      removeRow();
    }
  } else {
    if (included) {
      removeRow();
    } else {
      addRow();
    }
  }
  return changed;
}
// 及简版，为处理大量数据准备
export function toggleRowStatus2(statusArr, row, newVal, rowKey) {
  let changed = false;
  let index = -1;

  index = statusArr.findIndex((e) => {
    return e[rowKey] === row[rowKey];
  });

  const included = index !== -1;
  const addRow = () => {
    statusArr.push(row);
    changed = true;
  };
  const removeRow = () => {
    statusArr.splice(index, 1);
    changed = true;
  };
  if (typeof newVal === 'boolean') {
    if (newVal && !included) {
      addRow();
    } else if (!newVal && included) {
      removeRow();
    }
  } else {
    if (included) {
      removeRow();
    } else {
      addRow();
    }
  }
  return changed;
}

export function walkTreeNode(
  root,
  cb,
  childrenKey = 'children',
  lazyKey = 'hasChildren'
) {
  const isNil = array => !(Array.isArray(array) && array.length);

  function _walker(parent, children, level) {
    cb(parent, children, level);
    children.forEach(item => {
      if (item[lazyKey]) {
        cb(item, null, level + 1);
        return;
      }
      const children = item[childrenKey];
      if (!isNil(children)) {
        _walker(item, children, level + 1);
      }
    });
  }

  root.forEach(item => {
    if (item[lazyKey]) {
      cb(item, null, 0);
      return;
    }
    const children = item[childrenKey];
    if (!isNil(children)) {
      _walker(item, children, 0);
    }
  });
}
// 获取国际化
export function getLang() {
  return localStorage.getItem('yxtLang') || 'zh';
}

export function getLocalCacheObj(cacheId) {
  const lang = getLang();
  let customCacheStr = null;
  if (lang === 'zh') {
    customCacheStr = localStorage.getItem(`yxt-table-${cacheId}`);
  } else {
    customCacheStr = localStorage.getItem(`yxt-table-${lang}-${cacheId}`);
  }
  return customCacheStr;
}
export function setLocalCacheObj(cacheId, cacheObj) {
  const lang = getLang();
  if (lang === 'zh') {
    localStorage.setItem(`yxt-table-${cacheId}`, JSON.stringify(cacheObj));
  } else {
    localStorage.setItem(`yxt-table-${lang}-${cacheId}`, JSON.stringify(cacheObj));
  }
}

export function findKeys(selection, keys, rowKey, clearkeys = []) {
  selection.forEach((item) => {
    // 如果当前项的 key 在 keys 中，则添加到 clearkeys
    if (keys.includes(item[rowKey])) {
      clearkeys.push(item[rowKey]);
    }

    // 如果当前项有子节点，递归处理子节点
    if (item.children && item.children.length) {
      findKeys(item.children, keys, rowKey, clearkeys);
    }
  });

  return clearkeys;
}

// 获取row 根据key
export function getRowByKey(list, rowKey, key, childrenColumnName) {
  for (let item of list) {
    // 如果当前项的 key 匹配，则返回该项
    if (item[rowKey] === key) {
      return item;
    }
    // 如果当前项有 children，递归查找
    // console.log('item[lazyColumnIdentifier]', item[childrenColumnName]);
    if (item[childrenColumnName] && item[childrenColumnName].length > 0) {
      const result = getRowByKey(item[childrenColumnName], rowKey, key, childrenColumnName);
      // 如果在 children 中找到了匹配的项，返回结果
      if (result) {
        // console.log('result', result);
        return result;
      }
    }
  }
  // 如果没有找到匹配的项，返回 null
  return null;
}

// 获取obj 内的所有children 数据
export function collectChildren(obj, childList, childrenName = 'children') {
  // 检查对象是否存在并且有 children 属性
  if (obj && obj[childrenName] && Array.isArray(obj[childrenName])) {
    // 遍历 children 数组
    obj[childrenName].forEach((child) => {
      // 将子对象插入到 childList 数组中
      childList.push(child);
      // 递归调用，继续收集子对象的 children
      collectChildren(child, childList);
    });
  }
}

// 在tree 下， 根据 selectedMap 获取所有 勾选数据，包括勾选数据下的children
export function findSelectedData(data, selectedMap, childrenColumnName, rowKey) {
  const result = [];

  function recursiveSearch(items) {
    for (const item of items) {
      const rowId = getRowIdentity(item, rowKey);
      const rowInfo = selectedMap[rowId];
      if (rowInfo) {
        // 如果当前项的 id 在 selectedMap 中，将其添加到结果中
        result.push(item);
        // 获取所有children
        collectChildren(item, result, childrenColumnName);
      } else if (item.children && item.children.length > 0) {
        // 则递归进入
        recursiveSearch(item.children);
      }
    }
  }

  // 开始递归搜索
  recursiveSearch(data);

  return result;
}
// 去掉tree 内部属性
export function removeTreeProps(data, childName) {
  if (!data || typeof data !== 'object') {
    return; // 如果数据无效，直接返回
  }

  // 递归处理数组或对象
  if (Array.isArray(data)) {
    // 如果是数组，遍历每一项
    data.forEach((item) => removeTreeProps(item, childName));
  } else {
    // 删除指定的属性
    const propsToRemove = [
      '_level',
      '_expanded',
      '_display',
      '_loaded',
      '_lazy',
      '_parentId',
      '_nextId',
      '_prevId'
    ];
    propsToRemove.forEach((prop) => {
      if (data[prop] !== undefined) {
        delete data[prop];
      }
    });

    // 如果有子节点，递归处理子节点
    if (data[childName] && Array.isArray(data[childName])) {
      data[childName].forEach((child) => removeTreeProps(child, childName));
    }
  }
}
// 判断两个数组是否相等 通过label 判断
export function areColumnsEqual(a, b) {
  if (!a || !b) return false;
  // 获取两个数组的label 并去重
  const labelSeta = new Set();
  const labelSetb = new Set();
  Object.values(a).forEach((column) => {
    if (column.label) {
      labelSeta.add(column.label);
    }
  });
  Object.values(b).forEach((column) => {
    if (column.label) {
      labelSetb.add(column.label);
    }
  });
  const bLabelList = [...labelSetb];
  const aLabelList = [...labelSeta];
  // // 1. 检查键数量是否一致
  if (aLabelList.length !== bLabelList.length) return false;

  // 2. 检查所有键是否一致（不要求顺序）
  const keySet = new Set([...aLabelList, ...bLabelList]);
  if (keySet.size !== aLabelList.length) return false;
  return true;
}

// 比较两个表格头部分组是否相等
export function isGroupListEqual(a, b) {
  if (!a || !b) return false;
  if (a.length !== b.length) return false;
  for (let i = 0; i < a.length; i++) {
    const groupA = a[i];
    const groupB = b[i];
    // 比较groupName
    if (groupA.groupName !== groupB.groupName) return false;
    // 比较list数组
    const listA = groupA.list;
    const listB = groupB.list;
    if (listA.length !== listB.length) return false;
    for (let j = 0; j < listA.length; j++) {
      // 比较每个项的name属性
      if (listA[j].name !== listB[j].name) return false;
    }
  }
  return true;
}

export function isFixedColumn(
  index,
  fixed,
  store,
  realColumns
) {
  let start = 0;
  let after = index;
  const columns = store.states.columns;
  if (realColumns) {
    // fixed column supported in grouped header
    const curColumns = getCurrentColumns(realColumns[index]);
    const preColumns = columns.slice(0, columns.indexOf(curColumns[0]));

    start = preColumns.reduce(getColSpan, 0);
    after = start + curColumns.reduce(getColSpan, 0) - 1;
  } else {
    start = index;
  }

  let fixedLayout;
  switch (fixed) {
    case 'left':
      if (after < store.states.fixedLeafColumnsLength) {
        fixedLayout = 'left';
      }
      break;
    case 'right':
      if (start >= columns.length - store.states.rightFixedLeafColumnsLength) {
        fixedLayout = 'right';
      }
      break;
    default:
      if (after < store.states.fixedLeafColumnsLength) {
        fixedLayout = 'left';
      } else if (start >= columns.length - store.states.rightFixedLeafColumnsLength) {
        fixedLayout = 'right';
      }
  }

  return fixedLayout ? {
    direction: fixedLayout,
    start,
    after
  } : {};
}

function getColSpan(colSpan, column) {
  return colSpan + column.colSpan;
}

export const getCurrentColumns = (column) => {
  if (column.children) {
    return flatMap(column.children, getCurrentColumns);
  }
  return [column];
};

/**
 * 扁平化映射数组
 * @param {Array} array - 要处理的数组
 * @param {Function} callback - 处理每个元素的回调函数，接收三个参数：(当前元素, 索引, 原数组)
 * @returns {Array} 返回经过映射和扁平化处理后的新数组
 */
function flatMap(array, callback) {
  return array.reduce((acc, item, index) => {
    const result = callback(item, index, array);
    return acc.concat(Array.isArray(result) ? result : [result]);
  }, []);
}
function getOffset(offset, column) {
  return offset + (
    column.realWidth === null || Number.isNaN(column.realWidth)
      ? Number(column.width)
      : column.realWidth
  );
}
export const ensurePosition = (style, key) => {
  if (!style) return;
  const currentKey = getFixed(key);
  if (!Number.isNaN(style[currentKey])) {
    style[currentKey] = `${style[currentKey]}px`;
  }
  return style;
};
export const getFixedColumnOffset = (index, fixed, store, realColumns) => {
  const currentFixed = getFixed(fixed); // 函数调用;
  const { direction, start = 0, after = 0 } = isFixedColumn(
    index,
    currentFixed,
    store,
    realColumns
  );
  if (!direction) {
    return;
  }
  const styles = {};
  const isLeft = direction === 'left';
  const columns = store.states.columns;
  if (isLeft) {
    styles.left = columns.slice(0, start).reduce(getOffset, 0);
  } else {
    styles.right = columns
      .slice(after + 1)
      .reverse()
      .reduce(getOffset, 0);
  }
  return styles;
};

export function getFixedColumnsClass(
  // 类型泛型
  namespace,
  index,
  fixed,
  store,
  realColumns, // 可选参数
  offset = 0 // 默认参数
) {
  const currentFixed = getFixed(fixed); // 函数调用
  const classes = []; // const声明
  // 解构赋值
  const { direction, start, after } = isFixedColumn(
    index,
    currentFixed,
    store,
    realColumns
  );
  if (direction) {
    const isLeft = direction === 'left'; // const声明
    // 模板字符串
    classes.push(`${namespace}-fixed-column--${direction}`);
    if (
      isLeft &&
      after + offset === store.states.fixedLeafColumnsLength - 1
    ) {
      classes.push('is-last-column');
    } else if (
      !isLeft &&
      start - offset ===
        store.states.columns.length -
          store.states.rightFixedLeafColumnsLength
    ) {
      classes.push('is-first-column');
    }
  }
  return classes;
}
function getFixed(fixed) {
  return fixed === true || fixed === 'left' ? 'left' : fixed === 'right' ? 'right' : fixed;
}
